import { Component, signal, WritableSignal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import type { ICellRendererAngularComp } from 'ag-grid-angular';
import type { ICellRendererParams } from 'ag-grid-community';
import { RequestsStatusPillComponent } from '../../requests-status-pill/requests-status-pill.component';
import { ITableActivity } from '../models/table-acitivty.model';

@Component({
    selector: 'app-activity-status-cell',
    standalone: true,
    imports: [TranslateModule, RequestsStatusPillComponent],
    template: `
        @if (status()) {
            <div class="flex items-center gap-2 h-full whitespace-nowrap">
                <span>{{ 'common.request-detail.activity-stream.to' | translate }}</span>
                <app-requests-status-pill [status]="status()!" [isOnHold]="false" size="sm"></app-requests-status-pill>
            </div>
        } @else {
            <span>-</span>
        }
    `
})
export class ActivityStatusCellComponent implements ICellRendererAngularComp {
    protected status: WritableSignal<ITableActivity['status'] | undefined> = signal(undefined);

    public agInit(params: ICellRendererParams<ITableActivity>): void {
        this.status.set(params.data?.status);
    }

    public refresh(params: ICellRendererParams<ITableActivity>): boolean {
        this.status.set(params.data?.status);
        return true;
    }
}
